<template>
  <IntroComponentJa />
  <EducationComponentJa />
  <SkillComponentJa />
  <ProjectComponentJa />
  <CertiComponentJa />
</template>

<script>
import SkillComponentJa from "@/components/SkillComponentJa.vue";
import ProjectComponentJa from "@/components/ProjectComponentJa.vue";
import CertiComponentJa from "@/components/CertiComponentJa.vue";
import IntroComponentJa from "@/components/IntroComponentJa.vue";
import EducationComponentJa from "@/components/EducationComponentJa.vue";

export default {
  name: "HomePage",
  components: {
    SkillComponentJa,
    ProjectComponentJa,
    CertiComponentJa,
    IntroComponentJa,
    EducationComponentJa,
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Acme&family=Lato:wght@300;400;700&family=Noto+Serif+JP:wght@300;400;500;600;700&display=swap");
</style>
